import { loadStripe } from '@stripe/stripe-js';
import {
  useStripe,
  useElements,
  PaymentElement
} from '@stripe/react-stripe-js';
import React, { useState } from 'react';
import axios from 'axios';
import { paymentConfig } from '../config';
 
export const CheckoutForm = ({
  onSuccess,
  setPaymentData,
  onClose,
  processing,
  setProcessing,
  amount,
  clientSecret,
  currency = 'usd',
  currencySymbol = '$',
  language,
  displayLanguage,
  translations = {
    processing: 'Processing...',
    cancel: 'Cancel',
    pay: 'Pay',
    failedToConfirmPayment: 'Failed to confirm payment',
    errorConfirmingPayment: 'Error confirming payment',
    errorDuringPayment: 'An error occurred during payment'
  }
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [isPaymentComplete, setIsPaymentComplete] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
 
    setProcessing(true);
    setError(null);
 
    try {
      const { error: stripeError, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: { return_url: window.location.origin + '/success' },
        redirect: 'if_required'
      });
 
      if (stripeError) {
        setError(stripeError.message);
      } else {
        const paymentIntentId = paymentIntent.id;
        try {
          const response = await axios.post('/billing/confirm-payment', { paymentIntentId, language, displayLanguage });
          if (response.data.status === 200) {
            onSuccess();
            setPaymentData(response?.data);
          } else {
            setError(response.data.message || translations.failedToConfirmPayment);
          }
        } catch (confirmError) {
          setError(confirmError.response?.data?.message || translations.errorConfirmingPayment);
        }
      }
    } catch (err) {
      setError(err.message || translations.errorDuringPayment);
    } finally {
      setProcessing(false);
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement
        options={{
          wallets: {
            applePay: 'auto',
            googlePay: 'auto'
          },
          appearance: {
            theme: 'flat',
            variables: {
              colorPrimary: '#000',
            },
            rules: {
              '.Input': {
                boxShadow: 'none',
                border: '1px solid #ccc',
              }
            }
          }
        }}
        onChange={(event) => {
          setIsPaymentComplete(event.complete);
        }}
      />
 
      {error && <p className="alert alert-danger mt-3">{error}</p>}
      <div className="d-flex gap-2 mt-3">
        <button
          type="button"
          className="btn btn-outline-secondary flex-grow-1"
          onClick={onClose}
          disabled={processing}
        >
          {translations.cancel}
        </button>
        <button
          type="submit"
          className="btn btn-primary flex-grow-1"
          disabled={!stripe || processing || !isPaymentComplete}
        >
          {processing ? translations.processing : `${translations.pay} ${currencySymbol}${amount}`}
        </button>
      </div>
    </form>
  );
};
 
// Check if Stripe key is available
if (!paymentConfig.stripe.publishableKey) {
  console.error('Stripe publishable key is missing!');
}

export const stripePromise = loadStripe(paymentConfig.stripe.publishableKey);
 
 


// import { loadStripe } from '@stripe/stripe-js';
// import {
//   useStripe,
//   useElements,
//   PaymentElement
// } from '@stripe/react-stripe-js';
// import React, { useState } from 'react';
// import axios from 'axios';

// export const CheckoutForm = ({ 
//   onSuccess, 
//   setPaymentData, 
//   onClose, 
//   processing, 
//   setProcessing, 
//   amount, 
//   clientSecret 
// }) => {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [error, setError] = useState(null);
//   const [isPaymentComplete, setIsPaymentComplete] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!stripe || !elements) return;

//     setProcessing(true);
//     setError(null);

//     try {
//       const { error: stripeError, paymentIntent } = await stripe.confirmPayment({
//         elements,
//         confirmParams: { return_url: window.location.origin + '/success' },
//         redirect: 'if_required'
//       });

//       if (stripeError) {
//         setError(stripeError.message);
//       } else {
//         const paymentIntentId = paymentIntent.id;
//         try {
//           const response = await axios.post('/payment/confirm', { paymentIntentId });
//           if (response.data.status === 200) {
//             onSuccess();
//             setPaymentData(response?.data);
//           } else {
//             setError(response.data.message || 'Failed to confirm payment');
//           }
//         } catch (confirmError) {
//           setError(confirmError.response?.data?.message || 'Error confirming payment');
//         }
//       }
//     } catch (err) {
//       setError(err.message || 'An error occurred during payment');
//     } finally {
//       setProcessing(false);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <PaymentElement
//         options={{
//           wallets: {
//             applePay: 'auto',
//             googlePay: 'auto'
//           },
//           appearance: {
//             theme: 'flat',
//             variables: {
//               colorPrimary: '#000',
//             },
//             rules: {
//               '.Input': {
//                 boxShadow: 'none',
//                 border: '1px solid #ccc',
//               }
//             }
//           }
//         }}
//         onChange={(event) => {
//           setIsPaymentComplete(event.complete);
//         }}
//       />

//       {error && <p className="alert alert-danger mt-3">{error}</p>}
//       <div className="d-flex gap-2 mt-3">
//         <button
//           type="button"
//           className="btn btn-outline-secondary flex-grow-1"
//           onClick={onClose}
//           disabled={processing}
//         >
//           Cancel
//         </button>
//         <button
//           type="submit"
//           className="btn btn-primary flex-grow-1"
//           disabled={!stripe || processing || !isPaymentComplete}
//         >
//           {processing ? 'Processing...' : `Pay $${amount}`}
//         </button>
//       </div>
//     </form>
//   );
// };

//  export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY);
